export default [
  {
    path: '/admin',
    redirect: '/admin/dashboard',
    component: () => import('../../components/admin/Layout'),
    children: [
      {
        path: 'dashboard',
        name: 'admin.dashboard',
        component: () => import('../../views/admin/Dashboard'),
        meta: {
          roles: [1, 2, 3]
        }
      },
      {
        path: 'dietgroups',
        name: 'admin.dietgroups',
        component: () => import('../../views/admin/Dietgroups'),
        meta: {
          roles: [1, 2, 3]
        }
      },
      {
        path: 'food-database',
        name: 'admin.foodDatabase',
        component: () => import('../../views/admin/FoodDatabase'),
        meta: {
          roles: [1, 2]
        }
      },
      {
        path: 'drink-database',
        name: 'admin.drinksDatabase',
        component: () => import('../../views/admin/DrinkDatabase'),
        meta: {
          roles: [1, 2]
        }
      },
      {
        path: 'menu-database',
        name: 'admin.menuDatabase',
        component: () => import('../../views/admin/MenuDatabase'),
        meta: {
          roles: [1, 2]
        }
      },
      {
        path: 'food-archive',
        name: 'admin.foodArchive',
        component: () => import('../../views/admin/FoodArchive'),
        meta: {
          roles: [1, 2]
        }
      },
      {
        path: 'emails',
        name: 'admin.emails',
        component: () => import('../../views/admin/Emails'),
        meta: {
          roles: [1, 2]
        }
      },
      {
        path: 'drink-archive',
        name: 'admin.drinkArchive',
        component: () => import('../../views/admin/DrinkArchive'),
        meta: {
          roles: [1, 2]
        }
      },
      {
        path: 'menu-archive',
        name: 'admin.menuArchive',
        component: () => import('../../views/admin/MenuArchive'),
        meta: {
          roles: [1, 2]
        }
      },
      {
        path: 'institutions',
        name: 'admin.institutions',
        component: () => import('../../views/admin/Institutions'),
        meta: {
          roles: [1, 2]
        }
      },
      {
        path: 'delivery',
        name: 'admin.delivery',
        component: () => import('../../views/admin/Delivery'),
        meta: {
          roles: [1, 2, 3, 4, 5]
        }
      },
      {
        path: 'users',
        name: 'admin.users',
        component: () => import('../../views/admin/Users'),
        meta: {
          roles: [1, 2]
        }
      },
      {
        path: 'user-card',
        name: 'admin.userCard',
        component: () => import('../../views/admin/UserCard'),
        meta: {
          roles: [1, 2]
        }
      },
      {
        path: 'user-archive',
        name: 'admin.userArchive',
        component: () => import('../../views/admin/UserArchive'),
        meta: {
          roles: [1, 2]
        }
      },
      {
        path: 'orders',
        name: 'admin.orders',
        component: () => import('../../views/admin/Orders'),
        meta: {
          roles: [1, 2, 3, 4, 5]
        }
      },
      {
        path: 'orders-archive',
        name: 'admin.ordersArchive',
        component: () => import('../../views/admin/OrdersArchive'),
        meta: {
          roles: [1, 2, 3, 4, 5]
        }
      },
      {
        path: 'new-order',
        name: 'admin.newOrder',
        component: () => import('../../views/admin/NewOrderView.vue'),
        meta: {
          roles: [1, 2]
        }
      },
      {
        path: 'orders-items',
        name: 'admin.orders-items',
        component: () => import('../../views/admin/OrderItems'),
        meta: {
          roles: [1, 2, 3, 4, 5]
        }
      },
      {
        path: 'test',
        name: 'admin.test',
        component: () => import('../../views/admin/test'),
        meta: {
          roles: [1, 2]
        }
      },
      {
        path: 'invoices',
        name: 'admin.invoices',
        component: () => import('../../views/admin/InvoiceSystem'),
        meta: {
          roles: [1, 2]
        }
      },
      {
        path: 'credit',
        name: 'admin.credit',
        component: () => import('../../views/admin/CreditNote'),
        meta: {
          roles: [1, 2]
        }
      },
      {
        path: 'transactions',
        name: 'admin.transactions',
        component: () => import('../../views/admin/Transactions'),
        meta: {
          roles: [1, 2]
        }
      },
      {
        path: 'settings',
        name: 'admin.settings',
        component: () => import('../../views/admin/Settings'),
        meta: {
          roles: [1, 2]
        }
      },
      {
        path: 'institution-settings/:id',
        name: 'admin.institutionSettings',
        component: () => import('../../views/admin/InstitutionSettings'),
        meta: {
          roles: [1, 2]
        }
      },
      {
        path: 'overview',
        name: 'admin.overview',
        component: () => import('../../views/admin/Overview'),
        meta: {
          roles: [1, 2, 3, 4, 5]
        }
      },
      {
        path: 'personal-collection',
        name: 'admin.personalCollection',
        component: () => import('../../views/admin/PersonalCollection'),
        meta: {
          roles: [1, 2, 3, 4, 5]
        }
      }
    ]
  }
]
